import { useEffect } from 'react';
import { useMetadata, MetadataOptions } from '@/hooks/useMetadata';

export interface DocumentHeadProps extends MetadataOptions {
  /**
   * Whether to reset metadata to defaults when component unmounts
   * @default true
   */
  resetOnUnmount?: boolean;
}

export function DocumentHead({
  resetOnUnmount = true,
  ...metadataOptions
}: DocumentHeadProps) {
  const { setMetadata, resetMetadata } = useMetadata();

  useEffect(() => {
    setMetadata(metadataOptions);

    return () => {
      if (resetOnUnmount) {
        resetMetadata();
      }
    };
  }, [
    setMetadata,
    resetMetadata,
    resetOnUnmount,
    metadataOptions.title,
    metadataOptions.description,
    metadataOptions.titleKey,
    metadataOptions.descriptionKey,
    metadataOptions.appendAppName,
    metadataOptions,
  ]);

  return null;
}
